import { assetUrl } from "@/lib/assets";
export const CONTACT = {
  phone: "+91-9907088732",
  phoneRaw: "919907088732",
  email: "hello@socialpotato.in",
  address: "208, 2nd floor, Lakshaya Badgara Crest, near Tinku, New Palasia, Indore, Madhya Pradesh 452001",
  whatsapp: "https://wa.me/919907088732?text=Hi%2C%20I%27d%20like%20to%20grow%20my%20organic%20traffic%20with%20SEO.",
  calendly: "https://calendly.com/shashanktest2025/30min",
};

export const SERVICES = [
  {
    id: "seo",
    title: "SEO Services",
    desc: "Full-funnel organic strategy engineered to rank, convert and compound month over month.",
  },
  {
    id: "link-building",
    title: "Link Building",
    desc: "White-hat authority acquisition from relevant, high-trust domains — no spam, ever.",
  },
  {
    id: "ecommerce",
    title: "E-commerce SEO",
    desc: "Category & product page architecture built to capture buyers at every intent stage.",
  },
  {
    id: "shopify",
    title: "Shopify SEO",
    desc: "Store-specific technical fixes and content that turn browsers into repeat customers.",
  },
  {
    id: "local",
    title: "Local SEO",
    desc: "Own the map pack and dominate 'near me' searches in the markets that matter to you.",
  },
  {
    id: "saas",
    title: "SaaS SEO",
    desc: "Programmatic and BOFU content that lowers CAC and drives qualified trial signups.",
  },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "Deep keyword & intent research",
    desc: "We map every query your buyers type — from awareness to checkout — and prioritise the ones that move revenue, not vanity rankings.",
  },
  {
    no: "02",
    title: "Technical SEO foundation",
    desc: "Crawlability, Core Web Vitals, site architecture and indexation fixed at the root so Google can actually reward your content.",
  },
  {
    no: "03",
    title: "Content that converts",
    desc: "Editorial and commercial pages written for humans first, engineered for search — built to rank and to sell.",
  },
  {
    no: "04",
    title: "Authority & backlinks",
    desc: "Strategic, white-hat link building that earns trust signals from the domains your industry actually respects.",
  },
];

export const STATS = [
  { value: "50+", label: "Brands scaled" },
  { value: "6", label: "Industries served" },
  { value: "3 mo", label: "To first results" },
];

export const LOGOS = [
  { src: assetUrl("logos/clean_2.png"), name: "BMW Motorrad" },
  { src: assetUrl("logos/clean_3.png"), name: "BYD" },
  { src: assetUrl("logos/clean_6.png"), name: "Birkenstock" },
  { src: assetUrl("logos/clean_5.png"), name: "Radisson Indore" },
  { src: assetUrl("logos/clean_7.png"), name: "Phoenix Citadel" },
  { src: assetUrl("logos/clean_9.png"), name: "iNSPiRE — Apple Premium Partner" },
  { src: assetUrl("logos/clean_1.png"), name: "SquareFoot" },
  { src: assetUrl("logos/clean_12.png"), name: "vocaski" },
  { src: assetUrl("logos/clean_10.png"), name: "Samaro.ai" },
  { src: assetUrl("logos/clean_8.png"), name: "Knots by AMP" },
  { src: assetUrl("logos/clean_11.png"), name: "The Mnetta" },
];

// Real analytics proof (Google Search Console / GA4 / Semrush screenshots)
export const PROOF = [
  { src: assetUrl("img_18.png"), source: "Google Search Console", headline: "48.4K clicks · 5.45M impressions", sub: "Compounding organic growth", tall: true },
  { src: assetUrl("img_22.png"), source: "Google Search Console", headline: "40.6K vs 22.6K clicks", sub: "+80% clicks · 7.76M impressions · 6 months" },
  { src: assetUrl("img_15.png"), source: "Google Analytics 4", headline: "+121% engaged sessions", sub: "Organic search · year over year" },
  { src: assetUrl("img_17.png"), source: "Google Analytics 4", headline: "+280% organic sessions", sub: "14,961 vs 3,936 sessions" },
  { src: assetUrl("img_21.png"), source: "Google Search Console", headline: "35.1K vs 15.4K clicks", sub: "+128% clicks · 3.13M impressions · 6 months" },
  { src: assetUrl("img_23.png"), source: "Semrush", headline: "0 → 24.9K organic traffic", sub: "Sustained upward trajectory" },
  { src: assetUrl("img_14.png"), source: "Google Search Console", headline: "12.6K vs 6.4K clicks", sub: "+97% clicks · 3 months" },
  { src: assetUrl("img_16.png"), source: "Google Search Console", headline: "14.5K vs 5.5K clicks", sub: "+163% clicks · 735K impressions · 6 months" },
  { src: assetUrl("img_19.png"), source: "Google Search Console", headline: "17.9K clicks · 1.08M impressions", sub: "Steady long-term climb" },
  { src: assetUrl("img_13.png"), source: "Google Search Console", headline: "9.53K vs 5.1K clicks", sub: "+87% clicks · 501K impressions · 3 months" },
  { src: assetUrl("img_20.png"), source: "Google Search Console", headline: "14.6K vs 3.28K clicks", sub: "+345% clicks · 861K impressions · 6 months" },
  { src: assetUrl("img_24.png"), source: "Semrush", headline: "0 → 23K organic traffic", sub: "Branded + non-branded growth" },
];
